<nz-table [nzData]="formArray.controls" [nzBordered]="true" [nzSize]="'middle'" [nzPagination]="false"
    [nzShowPagination]="false" [nzNoResult]="null">
    <thead>
        <tr>
            <th>Order</th>
            <th>Name</th>
            <th>Localization Key</th>
            <th>Query Params</th>
            <th nzWidth="40%">URL</th>

            <th nzWidth="120px">Actions</th>
        </tr>
    </thead>
    <tbody>
        <tr *ngFor="let group of formArray.controls; let i = index" [formGroup]="group">
            <td>
                {{ group.get('order')?.value }}
            </td>
            <td><input nz-input formControlName="name" /></td>
            <td><input nz-input formControlName="localizationKey" /></td>
            <td><input nz-input formControlName="queryParams" /></td>
            <td><input nz-input formControlName="url" /></td>
            <td>
                <button nz-button nzType="link" type="button" (click)="moveUp(i)" [disabled]="i === 0"><i
                        class="fas fa-fw fa-chevron-up"></i></button>
                <button nz-button nzType="link" type="button" (click)="moveDown(i)"
                    [disabled]="i === formArray.length - 1"><i class="fas fa-fw fa-chevron-down"></i></button>
                <button nz-button nzType="link" type="button" nzDanger (click)="removeRow(i)"><i
                        class="fas fa-fw fa-trash"></i></button>
            </td>
        </tr>
    </tbody>
</nz-table>

<div style="margin-top: 16px;">
    <button type="button" nz-button nzType="dashed" (click)="addRow()">Add Row</button>
</div>